<div class="container">
    <!-- <i class="material-icons">home</i> -->
    <!-- <app-sidebar class="sidebar height"></app-sidebar> -->
    <app-video-screen></app-video-screen>
</div>
